module.exports = __webpack_public_path__ + "static/48-quantum-july2024-dea6f6540ecfc9a571e5d4f5368538f0.jpg";